import { remove } from 'diacritics'

export const simplify = (str: string): string => remove(str.toLowerCase())
